import { useState, useEffect } from 'react';

import { useServices } from '@/services/useServices';

export const useCustomizationPrice = (storeId) => {
  const { customizationService } = useServices();
  const [defaultPrice, setDefaultPrice] = useState(0);

  useEffect(() => {
    const subscription = customizationService.getCustomizationPrice(storeId).subscribe((custoPrice) => {
      setDefaultPrice(custoPrice?.value);
    });

    return () => subscription.unsubscribe();
  }, [storeId]);

  return defaultPrice;
};
